import { apiHolder as api, apis, getDingTalkSearchString, } from 'api';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { FLOLDER, MAIL_TAG_HOTKEY_LOCAL_KEY } from '@web-mail/common/constant';
import { MailSign, PreHeader, MailSignEnt, SocialLink, UnSubText, MailPreMailContent, MailForwardContent } from './mailClassnameConstant';
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const systemApi = api.api.getSystemApi();
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const storageApi = api.api.getDataStoreApi();
const inElectron = systemApi.isElectron();
export const mailIdinList = (mid, list) => {
    if (typeof mid === 'string' && list.length === 1 && mid === list[0]) {
        return true;
    }
    if (Array.isArray(mid) && mid.length === list.length && mid.every(id => list.includes(id))) {
        return true;
    }
    return false;
};
export const asyncMailList = (argMailList, sliceList) => {
    var _a, _b, _c;
    if (!asyncMailList || !sliceList)
        return [];
    const min = argMailList.length - sliceList.length;
    if (argMailList.length === 0 || sliceList.length === 0) {
        return [...argMailList, ...sliceList];
    }
    let offset = 0;
    for (let i = argMailList.length - 1; i >= min; i--) {
        const curMail = argMailList[i];
        if (((_a = curMail === null || curMail === void 0 ? void 0 : curMail.entry) === null || _a === void 0 ? void 0 : _a.id) === ((_c = (_b = sliceList[0]) === null || _b === void 0 ? void 0 : _b.entry) === null || _c === void 0 ? void 0 : _c.id)) {
            offset += 1;
            break;
        }
        offset += 1;
    }
    if (offset === sliceList.length) {
        return [...argMailList, ...sliceList];
    }
    return [...argMailList, ...sliceList.slice(offset)];
};
export const getCanActiveMailId = (mailList, selectedIds, activeId) => {
    const mailId2Index = {};
    const index2MailId = {};
    const selectedMap = {};
    selectedIds.forEach(item => {
        selectedMap[item] = true;
    });
    mailList.forEach((mail, index) => {
        mailId2Index[mail.entry.id] = index;
        index2MailId[index] = mail.entry.id;
    });
    let resMailId = null;
    let resMailIndex = null;
    if (!selectedIds.includes(activeId))
        return [activeId, mailId2Index[activeId]];
    for (let i = mailId2Index[activeId]; i < mailList.length; i++) {
        const curMailId = index2MailId[i];
        if (!selectedMap[curMailId]) {
            resMailId = curMailId;
            resMailIndex = i;
            break;
        }
    }
    if (resMailId == null && resMailIndex == null) {
        for (let i = mailId2Index[activeId]; i >= 0; i--) {
            const curMailId = index2MailId[i];
            if (!selectedMap[curMailId]) {
                resMailId = curMailId;
                resMailIndex = i;
                break;
            }
        }
    }
    return [resMailId, resMailIndex];
};
const itemHeight = 63;
const attachHeight = 32;
const statusHeight = 24;
export const getMailListRowHeight = (mail, isSearching = false) => {
    var _a, _b;
    if (mail) {
        let height = itemHeight;
        if (mail && ((_a = mail.entry.attachment) === null || _a === void 0 ? void 0 : _a.length)) {
            let attachment = [];
            attachment = (_b = mail.entry.attachment) === null || _b === void 0 ? void 0 : _b.filter(item => item.inlined == false && item.fileType !== 'ics' && item.type !== 'netfolder');
            if (attachment.length) {
                height += attachHeight;
            }
        }
        if (mail && mail.entry.sendStatus) {
            height += statusHeight;
        }
        if (mail && mail.entry.folder == 3 && (mail.entry.rcptCount || mail.entry.readCount)) {
            height += 25;
        }
        height += 23;
        return height + 1;
    }
    return 0;
};
export const getTopMailSumHeight = mailDataList => {
    let offset = 0;
    mailDataList.forEach(mail => {
        if (mail.entry.top) {
            offset += getMailListRowHeight(mail);
        }
    });
    return offset;
};
export const getTopMailNum = (mailList) => {
    let topCount = 0;
    mailList.forEach(item => {
        if (item.entry.top) {
            topCount += 1;
        }
    });
    return topCount;
};
export const mailConfigStateIsMerge = () => mailConfApi.getMailMergeSettings() == 'true';
export const mailLogicStateIsMerge = (fid, accountId, isSearching) => {
    var _a;
    const email = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
    const isMainAccount = !accountId || accountId === email;
    if (Number.isInteger(fid)) {
        return (mailConfigStateIsMerge() &&
            (fid === FLOLDER.DEFAULT || fid > 20 || fid === FLOLDER.TAG || fid === FLOLDER.REDFLAG || fid === FLOLDER.UNREAD) &&
            !isSearching &&
            isMainAccount);
    }
    return false;
};
export const filterSysMailTag = (mail) => {
    try {
        if (mail && mail.tags) {
            return Object.assign(Object.assign({}, mail), { tags: mail.tags.filter(tag => !tag.startsWith('%') && !tag.endsWith('%')) });
        }
    }
    catch (e) {
        console.error('[ filterSysMailTag Error]', e);
    }
    return mail;
};
export const conactMailList = (mailList = [], lastMailList = []) => {
    var _a, _b, _c, _d, _e;
    let list = [...mailList];
    const listMap = {};
    mailList.forEach((item, index) => {
        const { id } = item.entry;
        if (id) {
            listMap[item.entry.id] = [index];
        }
    });
    if (mailList && mailList.length) {
        for (let i = 0; i < lastMailList.length; i++) {
            const id = (_b = (_a = lastMailList[i]) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.id;
            if (!listMap[id]) {
                const index = i - 1;
                if (index >= 0) {
                    const preId = (_d = (_c = lastMailList[index]) === null || _c === void 0 ? void 0 : _c.entry) === null || _d === void 0 ? void 0 : _d.id;
                    if (preId && listMap[preId]) {
                        const [preIndex] = listMap[preId];
                        if (preIndex) {
                            list = [...mailList.slice(0, preIndex), ...(_e = lastMailList.slice(index)) === null || _e === void 0 ? void 0 : _e.filter(item => !listMap[item.entry.id])];
                            return list;
                        }
                    }
                }
            }
        }
    }
    return [...mailList, ...lastMailList.filter(item => !listMap[item.entry.id])];
};
export const isShowMailListTapByFolderId = (folderId, isSeaching = false) => {
    if (isSeaching) {
        return folderId == 1 || folderId == -33 || folderId >= 17;
    }
    return folderId == 1 || (folderId >= 17 && folderId != -199);
};
export const idIsTreadMail = (id) => {
    if (id) {
        try {
            const mailIdReg = /\d+/;
            const [realId] = id.split('--') || [''];
            const [res] = mailIdReg.exec(realId) || [null];
            if (res && res.length === realId.length) {
                return true;
            }
        }
        catch (_a) {
            return false;
        }
        return false;
    }
    return false;
};
export const getMailKey = (index, mail) => {
    if (mail && mail.entry && mail.entry.id) {
        return mail.entry.id;
    }
    return index + '';
};
export const openMailInWinow = (mail) => {
    const { id, _account, isTpMail, owner, tpMailInfo: { colleagueAccId, type: relatedEmailType, refId: relatedEmailRefId } = {}, mailFrom, mainAccount } = mail;
    if (id) {
        const isThread = idIsTreadMail(id);
        if (systemApi.isElectron()) {
            systemApi.createWindowWithInitData({ type: 'readMail', additionalParams: { account: _account } }, {
                eventName: 'initPage',
                eventData: { id: id, accountId: _account, isTpMail, owner, colleagueAccId, mailFrom, mainAccount, relatedEmailType, relatedEmailRefId },
                eventStrData: isThread ? 'isthread' : '',
                _account,
            });
        }
        else {
            window.open(`${systemApi.getContextPath()}/readMail/?id=${id}${getDingTalkSearchString(true)}${_account ? '&account=' + _account : ''}${isThread ? '&isthread=1' : ''}${isTpMail ? '&isTpMail=1' : ''}${owner ? '&owner=' + owner : ''}${colleagueAccId ? '&colleagueAccId=' + colleagueAccId : ''}${mailFrom ? '&mailFrom=' + mailFrom : ''}${mainAccount ? '&mainAccount=' + mainAccount : ''}${relatedEmailType ? '&relatedEmailType=' + relatedEmailType : ''}${relatedEmailRefId ? '&relatedEmailRefId=' + relatedEmailRefId : ''}`);
        }
    }
};
export const openReadOnlyUniversalInWindow = (mid, account = '') => {
    if (mid) {
        if (systemApi.isElectron()) {
            systemApi.createWindowWithInitData({ type: 'readOnlyUniversal', additionalParams: { account } }, { eventName: 'initPage', eventData: { mid }, eventStrData: '', _account: account });
        }
        else {
            window.open(`${systemApi.getContextPath()}/readOnlyUniversal/?id=${mid}${getDingTalkSearchString(true)}`, 'readMail', 'menubar=0,scrollbars=1,resizable=1,width=800,height=600');
        }
    }
};
export const openReadOnlyMailInWinow = (mid, teamId) => {
    if (mid && teamId) {
        if (systemApi.isElectron()) {
            systemApi.createWindowWithInitData({ type: 'readMailReadOnly', additionalParams: { account: '' } }, { eventName: 'initPage', eventData: { mid, teamId }, eventStrData: '', _account: '' });
        }
        else {
            window.open(`${systemApi.getContextPath()}/readMailReadOnly/?id=${mid}${getDingTalkSearchString(true)}&teamId=${teamId}`, 'readMail', 'menubar=0,scrollbars=1,resizable=1,width=800,height=600');
        }
    }
};
export const getMailIdFromList = (mailList) => {
    try {
        if (mailList && mailList.length) {
            return mailList.map(item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id; });
        }
    }
    catch (e) {
        console.error('getMailIdFromList error', e);
    }
    return [];
};
export const reOpenMail = async (item) => {
    const { id, source, optSenderStr } = item;
    const openParams = {
        id,
        mailType: 'draft',
        writeType: 'editDraft',
        withoutPlaceholder: true,
        optSenderStr: optSenderStr,
        _account: optSenderStr,
    };
    if (inElectron && source === 'writeMail') {
        const params = Object.assign(Object.assign({}, openParams), { writeWay: 'newWin' });
        mailApi.callWriteLetterFunc(params);
        message.success({ content: '已撤销发送' });
        return;
    }
    mailApi.callWriteLetterFunc(openParams);
    message.success({ content: '已撤销发送' });
};
export const getMailListByIdFromStore = (idList, mailStore) => {
    var _a;
    try {
        if (mailStore && idList && idList.length) {
            return ((_a = idList.map(id => mailStore[id])) === null || _a === void 0 ? void 0 : _a.filter(item => item)) || [];
        }
    }
    catch (e) {
        console.error('getMailListByIdFromStore error', e);
    }
    return [];
};
export const getCheckedMails = (activeIds, mailList) => {
    const list = [];
    if (activeIds && mailList) {
        activeIds.forEach(_id => {
            const mail = mailList.find(item => item.entry.id === _id);
            mail && list.push(mail);
        });
    }
    return list;
};
export const combineContent = (title, content) => {
    return title + '<headm></headm>' + content;
};
export const splitContent = (condition) => {
    try {
        return condition.split('<headm></headm>');
    }
    catch (e) {
        console.error(e);
    }
    return [];
};
export const changeContentByLocal = (toLang, comContent, content) => {
    var _a;
    try {
        const langListMap = content.entry.langListMap || {};
        const newContent = Object.assign(Object.assign({}, content), { entry: Object.assign(Object.assign({}, content.entry), { langListMap: Object.assign({}, langListMap), content: Object.assign({}, content.entry.content) }) });
        if (!((_a = newContent.entry.langListMap) === null || _a === void 0 ? void 0 : _a.origin)) {
            newContent.entry.langListMap.origin = combineContent(newContent.entry.title, newContent.entry.content.content);
        }
        const [titleStr, contentStr] = splitContent(comContent);
        if (titleStr != null) {
            newContent.entry.title = titleStr;
        }
        if (contentStr != null) {
            newContent.entry.content.content = contentStr;
        }
        newContent.entry.langType = toLang;
        if (newContent.entry.langListMap && !newContent.entry.langListMap[toLang]) {
            newContent.entry.langListMap[toLang] = comContent;
        }
        return newContent;
    }
    catch (e) {
        console.error(e);
    }
    return content;
};
const DEFAULT_TIMEOUT_LIST = [5000, 10000];
export const promiseIsTimeOut = (pr, name, config, timeoutConfigs) => {
    if (pr && pr.then != null && pr.finally != null) {
        const timeoutIds = [];
        for (const timeout of timeoutConfigs !== null && timeoutConfigs !== void 0 ? timeoutConfigs : DEFAULT_TIMEOUT_LIST) {
            const key = setTimeout(() => {
                const resConfig = config ? Object.assign(Object.assign({}, config), { timeout }) : { timeout };
                trackApi.track(name, resConfig);
            }, timeout);
            timeoutIds.push(key);
        }
        pr.finally(() => {
            for (const id of timeoutIds) {
                clearTimeout(id);
            }
        });
    }
    return pr;
};
export const getStateFromLocalStorage = (stateName) => {
    var _a;
    try {
        const serializedState = (_a = storageApi.getSync(stateName)) === null || _a === void 0 ? void 0 : _a.data;
        if (serializedState) {
            return JSON.parse(serializedState);
        }
        return null;
    }
    catch (err) {
        return null;
    }
};
export const setStateToLocalStorage = (stateName, state) => {
    try {
        const serializedState = JSON.stringify(state);
        storageApi.putSync(stateName, serializedState);
    }
    catch (err) {
        console.error(`Error setting state ${stateName} to localStorage: ${err}`);
    }
};
export const getHKFromLocalByAccount = (account) => {
    var _a;
    try {
        const map = getStateFromLocalStorage(MAIL_TAG_HOTKEY_LOCAL_KEY) || {};
        const accountKey = ((_a = systemApi.getCurrentUser(account)) === null || _a === void 0 ? void 0 : _a.id) || account;
        if (accountKey) {
            return map[accountKey] || {};
        }
    }
    catch (e) {
        console.error('[error] getHKFromLocal', e);
    }
    return {};
};
export const saveHKToLocal = (params) => {
    try {
        const { name, hotKey, account } = params;
        if (name) {
            const map = getHKFromLocalByAccount(account);
            if (hotKey && hotKey.length) {
                map[name] = hotKey;
            }
            saveHKMapToLocalByAccount(map, account);
            return map;
        }
    }
    catch (e) {
        console.error('[error] saveHKToLocal', e);
    }
    return {};
};
export const saveHKMapToLocalByAccount = (map, account) => {
    var _a;
    try {
        const accountKey = ((_a = systemApi.getCurrentUser(account)) === null || _a === void 0 ? void 0 : _a.id) || account;
        if (accountKey) {
            const localMap = getStateFromLocalStorage(MAIL_TAG_HOTKEY_LOCAL_KEY) || {};
            localMap[accountKey] = map;
            setStateToLocalStorage(MAIL_TAG_HOTKEY_LOCAL_KEY, localMap);
        }
    }
    catch (e) {
        console.error('[error] saveHKMapToLocalByAccount', e);
    }
};
export const deleteHkByTagName = (tagName, account) => {
    try {
        if (tagName) {
            const map = getHKFromLocalByAccount(account);
            delete map[tagName];
            saveHKMapToLocalByAccount(map, account);
            return map;
        }
    }
    catch (e) {
        console.error('[error] deleteHkByTagName', e);
    }
    return {};
};
export const updateHKBindTagName = (params) => {
    try {
        const { oldName, name, hotKey, account } = params;
        if (oldName && name) {
            const map = getHKFromLocalByAccount(account);
            delete map[oldName];
            if (!hotKey || hotKey.length == 0) {
                delete map[name];
            }
            else {
                map[name] = hotKey || map[oldName];
            }
            saveHKMapToLocalByAccount(map, account);
            return map;
        }
    }
    catch (e) {
        console.error('[error] updateHKBindTagName', e);
    }
};
export const checkLocalHk = (mailTagList, account) => {
    try {
        const map = getHKFromLocalByAccount(account);
        const tagMap = {};
        mailTagList.forEach(item => {
            tagMap[item[0]] = true;
        });
        const filterMap = {};
        Object.keys(map).forEach(key => {
            if (tagMap[key]) {
                filterMap[key] = map[key];
            }
        });
        saveHKMapToLocalByAccount(filterMap, account);
    }
    catch (e) {
        console.error('[error] checkLocalHk', e);
    }
};
export const getAllAccountHK = () => {
    try {
        const map = getStateFromLocalStorage(MAIL_TAG_HOTKEY_LOCAL_KEY) || {};
        return map;
    }
    catch (e) {
        console.error('[error] getAllAccountHK', e);
    }
    return {};
};
export const getHKListFromTab2 = (tab2) => {
    try {
        const list = [];
        Object.keys(tab2).forEach(key => {
            list.push(tab2[key].join('+'));
        });
        return list;
    }
    catch (e) {
        console.error('[error] getHKListFromTab2', e);
    }
    return [];
};
export const getKeyString = (event) => {
    let keyString = '';
    try {
        const keyList = [];
        if (event.metaKey) {
            keyList.push('command');
        }
        if (event.ctrlKey) {
            keyList.push('ctrl');
        }
        if (event.shiftKey) {
            keyList.push('shift');
        }
        if (event.altKey) {
            keyList.push('alt');
        }
        keyList.push(event.key.toLowerCase());
        keyString = keyList.join('+');
    }
    catch (e) {
        console.error('[error] getKeyString', e);
    }
    return keyString;
};
export const deleteNode = (root, selector) => {
    const removeNode = root.querySelector(selector);
    removeNode === null || removeNode === void 0 ? void 0 : removeNode.remove();
};
const deleteAllNode = (root, selector) => {
    const removeNodes = root.querySelectorAll(selector);
    removeNodes.forEach(node => node.remove());
};
export const getMailContentEl = (content) => {
    if (typeof DOMParser !== 'undefined') {
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, 'text/html');
        return doc.documentElement;
    }
    else {
        let node = null;
        node = document.createElement('div');
        node.innerHTML = content;
        return node;
    }
};
export const getMailContentText = (options) => {
    const { content, removeSign, removeUnSubText } = options;
    let node = getMailContentEl(content);
    if (removeSign) {
        deleteNode(node, `.${MailSign}`);
    }
    deleteAllNode(node, `.${SocialLink}`);
    deleteNode(node, `#${PreHeader}`);
    deleteNode(node, `.${MailSignEnt}`);
    deleteNode(node, `.${MailPreMailContent}`);
    deleteNode(node, `#${MailForwardContent}`);
    deleteAllNode(node, `style`);
    deleteAllNode(node, `title`);
    deleteAllNode(node, `script`);
    if (removeUnSubText) {
        deleteAllNode(node, `.${UnSubText}`);
    }
    const result = node && node.innerText ? node.innerText.trim() : '';
    return result;
};
export const getMailListAccount = (mailList) => {
    const accountSet = new Set();
    mailList.forEach(mail => {
        accountSet.add(mail._account || '');
    });
    return Array.from(accountSet);
};
export const mailListSortByAccount = (mailList) => {
    const mailMap = {};
    mailList.forEach(mail => {
        const account = mail._account || '';
        if (!mailMap[account]) {
            mailMap[account] = [];
        }
        mailMap[account].push(mail);
    });
    return mailMap;
};
export const mailListSortByAccountToId = (mailList) => {
    const mailMap = {};
    mailList.forEach(mail => {
        const account = mail._account || '';
        if (!mailMap[account]) {
            mailMap[account] = [];
        }
        mailMap[account].push(mail.entry.id);
    });
    return mailMap;
};
